import BusinessDetailsActions from '@/components/businesses/BusinessDetailsActions';
import BusinessDetailsInfo from '@/components/businesses/BusinessDetailsInfo';
import BusinessDetailsView from '@/components/businesses/BusinessDetailsView';
import BusinessDocuments from '@/components/businesses/BusinessDocuments';
import BusinessMembersTable from '@/components/businesses/BusinessMembersTable';
import EditBusinessMembersModal from '@/components/businesses/EditBusinessMembersModal';
import { SVButton, SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetBusinessDetails } from '@/hooks/requests/useBusinesses';
import { Card, Grid, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

export default function BusinessDetailsPage() {
  const navigate = useNavigate();
  const { uuid = '' } = useParams();
  const { businessDetails, isBusinessDetailsPending } =
    useGetBusinessDetails(uuid);

  if (isBusinessDetailsPending) {
    return (
      <DefaultLayout header="">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!businessDetails) {
    return (
      <DefaultLayout header="">
        <Card>
          <Typography>
            Something went wrong retreiving the business. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const { legalBusinessName, members, company, advisors } = businessDetails;

  return (
    <DefaultLayout
      header={`${legalBusinessName} Details`}
      buttons={[
        <SVButton
          onClick={() => navigate(`${ROUTES.BUSINESSES_EDIT_PARAMS}/${uuid}`)}
          fullWidth
          key="add"
          aria-label="Edit Business">
          Edit
        </SVButton>,
      ]}
      breadcrumb={[
        { label: 'Businesses', href: ROUTES.BUSINESSES },
        { label: legalBusinessName, isActive: true },
      ]}>
      <Stack spacing={2}>
        <BusinessDetailsInfo businessDetails={businessDetails} />
        <Card>
          <Typography variant="h5" mb={2}>
            Members
          </Typography>
          <BusinessMembersTable members={members} />
          <EditBusinessMembersModal
            members={members}
            companyId={company?.uuid}
            advisors={advisors ? advisors.map(advisor => advisor.uuid) : []}
          />
        </Card>
        <BusinessDocuments />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <BusinessDetailsView businessDetails={businessDetails} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <BusinessDetailsActions businessDetails={businessDetails} />
          </Grid>
        </Grid>
      </Stack>
    </DefaultLayout>
  );
}
